import request from './request'

// 获取用户列表
export function getUserList() {
  return request({
    url: '/api/user/web/users',
    method: 'get'
  })
}

// 删除用户
export function deleteUser(userId) {
  return request({
    url: `/api/users/${userId}`,
    method: 'delete'
  })
}